import { SagaIterator } from "redux-saga";
import { CreateStatementOfAccountsRequest, StatementOfAccountsReduxTypes } from "./types";
import { call, fork, put, takeEvery } from "redux-saga/effects";
import { createStatementOfAccountsApi } from "./api";

function* createStatementOfAccounts({ payload }: CreateStatementOfAccountsRequest): SagaIterator {
    try {
        const response = yield call(createStatementOfAccountsApi, payload);
        yield put({
            type: StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT_ERROR,
            payload: { error: error }
        })
    }
}

export function* watchCreateStatementOfAccounts() {
    yield takeEvery(StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT, createStatementOfAccounts)
}

function* statementOfAccountsSaga() {
    yield fork(watchCreateStatementOfAccounts)
}

export default statementOfAccountsSaga